import { t as tBase } from "i18next";
import { Trans as TransBase, useTranslation as useTranslationBase, } from "react-i18next";
import { formatDate } from "./formatDate";
import { i18n, initI18n } from "./init";
import { UI_LOCALES, resolveUiLocale, uiLocalePrimarySubtag, } from "./uiLocale";
export * from "./localePath";
export * from "./typedKeys";
export { backendErrorCode, errorMessage } from "./errorMessage";
export { solverErrorMessage, } from "./solverErrorMessage";
export { formatDate, i18n, initI18n, UI_LOCALES, resolveUiLocale, uiLocalePrimarySubtag, };
/** Bound to the single instance. Never call it at module scope: init runs first. */
export const t = tBase;
export const useTranslation = (ns) => useTranslationBase(ns);
/**
 * For sentences with markup only; everything else is `t()`. Typed with an
 * empty options type on purpose: the library default `{ context: undefined }`
 * makes `FilterKeysByContext` drop every key without strictNullChecks
 * (`undefined extends string` is true there), so `context` is not supported.
 */
export const Trans = TransBase;
//# sourceMappingURL=index.js.map